import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
  Typography,
  TextField,
  SelectChangeEvent
} from '@mui/material';
import { Button } from 'base/src/components/Button';
import Drawer from 'base/src/components/Drawer';

interface StatusOption {
  id: string;
  nome: string;
}

interface PremiacaoTipoOption {
  id: string;
  nome: string;
}

export interface FilterDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  statusFilter: string[];
  // eslint-disable-next-line no-unused-vars
  onStatusFilterChange: (event: SelectChangeEvent<string[]>) => void;
  premiacaoTipoFilter: string[];
  // eslint-disable-next-line no-unused-vars
  onPremiacaoTipoFilterChange: (event: SelectChangeEvent<string[]>) => void;
  dateStart: string;
  dateEnd: string;
  // eslint-disable-next-line no-unused-vars
  onDateStartChange: (value: string) => void;
  // eslint-disable-next-line no-unused-vars
  onDateEndChange: (value: string) => void;
  onApplyFilters: () => void;
  onClearFilters: () => void;
  statusOptions: StatusOption[];
  premiacaoTipoOptions: PremiacaoTipoOption[];
}

function FilterDrawer({
  isOpen,
  onClose,
  statusFilter,
  onStatusFilterChange,
  premiacaoTipoFilter,
  onPremiacaoTipoFilterChange,
  dateStart,
  dateEnd,
  onDateStartChange,
  onDateEndChange,
  onApplyFilters,
  onClearFilters,
  statusOptions,
  premiacaoTipoOptions
}: FilterDrawerProps) {

  // Render selected values in multi-select for status
  function renderSelectedStatusValues(selected: string[]) {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {selected.map((value) => {
          const status = statusOptions.find(s => s.id === value);
          return (
            <Chip
              key={value}
              label={status?.nome}
              size="small"
              color="primary"
              variant="outlined"
              sx={{
                borderRadius: 1,
                height: 20,
                fontSize: '0.75rem'
              }}
            />
          );
        })}
      </Box>
    );
  }

  // Render selected values in multi-select for premiacao tipo
  function renderSelectedPremiacaoTipoValues(selected: string[]) {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {selected.map((value) => {
          const tipo = premiacaoTipoOptions.find(t => t.id === value);
          return (
            <Chip
              key={value}
              label={tipo?.nome}
              size="small"
              color="primary"
              variant="outlined"
              sx={{
                borderRadius: 1,
                height: 20,
                fontSize: '0.75rem'
              }}
            />
          );
        })}
      </Box>
    );
  }

  return (
    <Drawer isOpen={isOpen} onClose={onClose} width="400px">
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        p: 3
      }}>
        <Typography variant="h6" sx={{ mb: 3, color: 'grey.800', fontWeight: 600 }}>
          Filtros
        </Typography>

        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <FormControl size="small" fullWidth>
            <InputLabel>Status</InputLabel>
            <Select
              multiple
              value={statusFilter}
              onChange={onStatusFilterChange}
              label="Status"
              renderValue={renderSelectedStatusValues}
              sx={{
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'primary.main',
                },
              }}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography variant="subtitle2" sx={{ color: 'grey.700', fontWeight: 600 }}>
            Período
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <TextField
              label="De"
              type="date"
              size="small"
              fullWidth
              value={dateStart}
              onChange={(e) => onDateStartChange(e.target.value)}
              slotProps={{ inputLabel: { shrink: true } }}
            />
            <TextField
              label="Até"
              type="date"
              size="small"
              fullWidth
              value={dateEnd}
              onChange={(e) => onDateEndChange(e.target.value)}
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </Box>

          <FormControl size="small" fullWidth>
            <InputLabel>Tipo de Premiação</InputLabel>
            <Select
              multiple
              value={premiacaoTipoFilter}
              onChange={onPremiacaoTipoFilterChange}
              label="Tipo de Premiação"
              renderValue={renderSelectedPremiacaoTipoValues}
              sx={{
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'primary.main',
                },
              }}
            >
              {premiacaoTipoOptions.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.nome}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 'auto', pt: 3 }}>
          <Button
            size="md"
            variant="primary"
            onClick={onApplyFilters}
            full
          >
            Aplicar Filtros
          </Button>
          <Button
            size="md"
            variant="secondary"
            onClick={onClearFilters}
            full
          >
            Limpar
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
}

export default FilterDrawer;
